import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { ApeDrawerComponent } from "../ape-drawer/ape-drawer.component";
import { ApeButtonComponent } from "../ape-button/ape-button.component";
import { MenuItem } from "primeng/api";
import { TRANSLATION_KEYS } from "src/app/constants/translations/translation-keys";
import { ApeMultiSelectComponent } from "../ape-multi-select/ape-multi-select.component";

@Component({
  selector: "ape-monitoring-details-filter-process-drawer",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslatePipe,
    ApeDrawerComponent,
    ApeButtonComponent,
    ApeMultiSelectComponent
  ],
  templateUrl: "./ape-monitoring-details-filter-process-drawer.component.html"
})
export class ApeMonitoringDetailsFilterProcessDrawerComponent {
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  @Input({ required: true })
  visible!: boolean;

  @Input()
  feedback360StatusOptions: MenuItem[] = [];

  @Input()
  selfAssessmentStatusOptions: MenuItem[] = [];

  @Input()
  evaluationStatusOptions: MenuItem[] = [];

  @Input()
  deliveryStatusOptions: MenuItem[] = [];

  @Input()
  developmentPlanStatusOptions: MenuItem[] = [];

  @Input()
  selectedFeedback360Statuses: MenuItem[] = [];

  @Input()
  selectedSelfAssessmentStatuses: MenuItem[] = [];

  @Input()
  selectedEvaluationStatuses: MenuItem[] = [];

  @Input()
  selectedDeliveryStatuses: MenuItem[] = [];

  @Input()
  selectedDevelopmentPlanStatuses: MenuItem[] = [];

  @Input()
  buOptions: MenuItem[] = [];

  @Input()
  officeOptions: MenuItem[] = [];

  @Input()
  departmentOptions: MenuItem[] = [];

  @Input()
  companyOptions: MenuItem[] = [];

  @Input()
  evaluatorOptions: MenuItem[] = [];

  @Input()
  selectedBUs: MenuItem[] = [];

  @Input()
  selectedOffices: MenuItem[] = [];

  @Input()
  selectedDepartments: MenuItem[] = [];

  @Input()
  selectedCompanies: MenuItem[] = [];

  @Input()
  selectedEvaluators: MenuItem[] = [];

  @Input()
  cancelLabel: string = "generic.CANCEL";

  @Input()
  confirmLabel: string = "";

  @Input()
  title: string = "";

  @Input()
  activeFiltersCount: number = 0;

  @Output()
  onCancel = new EventEmitter<void>();

  @Output()
  onConfirm = new EventEmitter<void>();

  @Output()
  feedback360StatusesChange = new EventEmitter<MenuItem[]>();

  @Output()
  selfAssessmentStatusesChange = new EventEmitter<MenuItem[]>();

  @Output()
  evaluationStatusesChange = new EventEmitter<MenuItem[]>();

  @Output()
  deliveryStatusesChange = new EventEmitter<MenuItem[]>();

  @Output()
  developmentPlanStatusesChange = new EventEmitter<MenuItem[]>();

  @Output()
  buChange = new EventEmitter<MenuItem[]>();

  @Output()
  officeChange = new EventEmitter<MenuItem[]>();

  @Output()
  departmentChange = new EventEmitter<MenuItem[]>();

  @Output()
  companyChange = new EventEmitter<MenuItem[]>();

  @Output()
  evaluatorChange = new EventEmitter<MenuItem[]>();

  @Output()
  onResetFilters = new EventEmitter<void>();

  protected onCancelClick(): void {
    this.onCancel.emit();
  }

  protected onConfirmClick(): void {
    this.onConfirm.emit();
  }

  protected onFeedback360StatusesChange(selected: MenuItem[]): void {
    this.selectedFeedback360Statuses = selected;
    this.feedback360StatusesChange.emit(selected);
  }

  protected onSelfAssessmentStatusesChange(selected: MenuItem[]): void {
    this.selectedSelfAssessmentStatuses = selected;
    this.selfAssessmentStatusesChange.emit(selected);
  }

  protected onEvaluationStatusesChange(selected: MenuItem[]): void {
    this.selectedEvaluationStatuses = selected;
    this.evaluationStatusesChange.emit(selected);
  }

  protected onDeliveryStatusesChange(selected: MenuItem[]): void {
    this.selectedDeliveryStatuses = selected;
    this.deliveryStatusesChange.emit(selected);
  }

  protected onDevelopmentPlanStatusesChange(selected: MenuItem[]): void {
    this.selectedDevelopmentPlanStatuses = selected;
    this.developmentPlanStatusesChange.emit(selected);
  }

  protected onBUChange(selected: MenuItem[]): void {
    this.selectedBUs = selected;
    this.buChange.emit(selected);
  }

  protected onOfficeChange(selected: MenuItem[]): void {
    this.selectedOffices = selected;
    this.officeChange.emit(selected);
  }

  protected onDepartmentChange(selected: MenuItem[]): void {
    this.selectedDepartments = selected;
    this.departmentChange.emit(selected);
  }

  protected onCompanyChange(selected: MenuItem[]): void {
    this.selectedCompanies = selected;
    this.companyChange.emit(selected);
  }

  protected onEvaluatorChange(selected: MenuItem[]): void {
    this.selectedEvaluators = selected;
    this.evaluatorChange.emit(selected);
  }

  protected resetFiltersClick(): void {
    this.selectedFeedback360Statuses = [];
    this.selectedSelfAssessmentStatuses = [];
    this.selectedEvaluationStatuses = [];
    this.selectedDeliveryStatuses = [];
    this.selectedBUs = [];
    this.selectedOffices = [];
    this.selectedDepartments = [];
    this.selectedCompanies = [];
    this.selectedEvaluators = [];
    this.onResetFilters.emit();
  }
}
